const config = {
	GOOGLE_MAPS_API_KEY: 'AIzaSyDd1SKqt2fJNWxW-NLv_unuAZjTzqU2wMg'
};

export {
	config
};